import React, { useState } from "react";
import { db, auth, googleProvider } from "../firebase";
import {
  collection, setDoc, doc, getDocs, query, where
} from "firebase/firestore";
import { signInWithPopup } from "firebase/auth";
import googleLogo from "../assets/google_logo.png";

const COLOR = "#667eea";

function LoginRegister() {
  const [isLogin, setIsLogin] = useState(true);
  const [userType, setUserType] = useState("general");
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [nickname, setNickname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");
  const [birth, setBirth] = useState("");
  const [associationName, setAssociationName] = useState("");
  const [businessNumber, setBusinessNumber] = useState("");
  const [associationAddress, setAssociationAddress] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [sports, setSports] = useState([]);
  const [idCheck, setIdCheck] = useState(false);
  const [nicknameCheck, setNicknameCheck] = useState(false);
  const [emailCheck, setEmailCheck] = useState(false);
  const [associationNameCheck, setAssociationNameCheck] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);

  const AVAILABLE_SPORTS = ["탁구", "배드민턴", "테니스", "볼링", "축구", "농구", "배구", "야구"];

  function validatePassword(password) {
    const checks = {
      length: password.length >= 8,
      upper: /[A-Z]/.test(password),
      lower: /[a-z]/.test(password),
      number: /\d/.test(password),
      special: /[!@#$%^&*()_+=-]/.test(password)
    };
    const isValid = Object.values(checks).every(check => check);
    const issues = [];
    if (!checks.length) issues.push("8자 이상");
    if (!checks.upper) issues.push("대문자");
    if (!checks.lower) issues.push("소문자");
    if (!checks.number) issues.push("숫자");
    if (!checks.special) issues.push("특수문자");
    return { isValid, issues };
  }

  const showPopupMessage = (message, type) => {
    setPopupMessage(message);
    setPopupType(type);
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };

  const checkDuplicate = async (type, value, setter) => {
    setError(""); setInfo("");
    if (!value.trim()) {
      const fieldName = type === "id" ? "아이디" : type === "nickname" ? "닉네임" : type === "email" ? "이메일" : "협회명";
      showPopupMessage(`${fieldName}을 입력하세요.`, "error");
      return;
    }
    if (type === "id" && value.length < 4) {
      showPopupMessage("아이디는 4자 이상이어야 합니다.", "error");
      return;
    }
    setLoading(true);
    try {
      const q = query(collection(db, "users"), where(type, "==", value));
      const snap = await getDocs(q);
      if (!snap.empty) {
        setter(false);
        const fieldName = type === "id" ? "아이디" : type === "nickname" ? "닉네임" : type === "email" ? "이메일" : "협회명";
        showPopupMessage(`이미 사용중인 ${fieldName}입니다.`, "error");
      } else {
        setter(true);
        const fieldName = type === "id" ? "아이디" : type === "nickname" ? "닉네임" : type === "email" ? "이메일" : "협회명";
        showPopupMessage(`✓ 사용 가능한 ${fieldName}입니다!`, "success");
      }
    } catch (error) {
      console.error("중복확인 오류:", error);
      showPopupMessage("확인 중 오류가 발생했습니다.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSportToggle = (sport) => {
    setSports(prev =>
      prev.includes(sport) ? prev.filter(s => s !== sport) : [...prev, sport]
    );
  };

  const handleLogin = async () => {
    setError(""); setInfo("");
    if (!id || !pw) {
      setError("아이디와 비밀번호를 입력하세요.");
      return;
    }
    setLoading(true);
    try {
      const q = query(collection(db, "users"), where("id", "==", id), where("pw", "==", pw));
      const snap = await getDocs(q);
      if (snap.empty) {
        setError("아이디 또는 비밀번호가 일치하지 않습니다.");
        return;
      }
      const user = snap.docs[0].data();
      if (user.userType === 'association' && !user.isApproved) {
        setError("협회 승인 대기 중입니다. 관리자 승인 후 이용하세요.");
        return;
      }
      localStorage.setItem("user", JSON.stringify(user));
      window.location.href = user.userType === 'association' ? "/association" : "/";
    } catch (error) {
      console.error("로그인 오류:", error);
      setError("로그인 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError(""); setInfo("");
    try {
      setLoading(true);
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const q = query(collection(db, "users"), where("id", "==", user.email));
      const snap = await getDocs(q);
      let userData;
      if (snap.empty) {
        let baseNick = user.displayName || user.email.split("@")[0];
        let newNick = baseNick;
        let cnt = 1;
        while (true) {
          const nQ = query(collection(db, "users"), where("nickname", "==", newNick));
          const nSnap = await getDocs(nQ);
          if (nSnap.empty) break;
          newNick = `${baseNick}${cnt++}`;
        }
        userData = {
          id: user.email,
          pw: "",
          nickname: newNick,
          phone: "",
          email: user.email,
          gender: "",
          birth: "",
          userType: "general",
          mmr: 1000,
          role: "user"
        };
        await setDoc(doc(db, "users", user.email), userData);
      } else {
        userData = snap.docs[0].data();
      }
      localStorage.setItem("user", JSON.stringify(userData));
      window.location.href = "/";
    } catch (e) {
      console.error("구글 로그인 오류:", e);
      setError("구글 로그인에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    setError(""); setInfo("");
    if (!id || !pw || !confirmPw || !email || !phone) {
      setError("필수 항목을 모두 입력하세요.");
      return;
    }
    if (pw !== confirmPw) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }
    const passwordValidation = validatePassword(pw);
    if (!passwordValidation.isValid) {
      setError(`비밀번호 조건을 만족하지 않습니다: ${passwordValidation.issues.join(", ")} 필요`);
      return;
    }
    if (!idCheck || !emailCheck) {
      setError("중복확인을 완료하세요.");
      return;
    }
    let userData = { id, pw, email, phone, userType, mmr: 1000 };
    if (userType === "general") {
      if (!nickname || !gender || !birth) {
        setError("모든 항목을 입력하세요.");
        return;
      }
      if (!nicknameCheck) {
        setError("닉네임 중복확인을 완료하세요.");
        return;
      }
      userData = { ...userData, nickname, name: nickname, gender, birth, role: 'user' };
    } else {
      if (!associationName || !businessNumber || !associationAddress || !representativeName || sports.length === 0) {
        setError("모든 협회 정보를 입력하세요.");
        return;
      }
      if (!associationNameCheck) {
        setError("협회명 중복확인을 완료하세요.");
        return;
      }
              userData = { ...userData, associationName, name: associationName, businessNumber, associationAddress, representativeName, sports, isApproved: false, role: 'user' };
    }
    setLoading(true);
    try {
      await setDoc(doc(db, "users", id), userData);
      setInfo(userType === "association" ? "협회 회원가입 완료! 관리자 승인 후 이용 가능합니다." : "회원가입 완료! 로그인하세요.");
      setTimeout(() => {
        setIsLogin(true);
        resetForm();
      }, 2000);
    } catch (error) {
      console.error("회원가입 오류:", error);
      setError("회원가입 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setId(""); setPw(""); setConfirmPw(""); setNickname(""); setPhone(""); setEmail("");
    setGender(""); setBirth(""); setAssociationName(""); setBusinessNumber("");
    setAssociationAddress(""); setRepresentativeName(""); setSports([]);
    setIdCheck(false); setNicknameCheck(false); setEmailCheck(false); setAssociationNameCheck(false);
    setError(""); setInfo("");
  };

  const styles = {
    container: {
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "16px",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    card: {
      background: "#fff",
      borderRadius: 24,
      padding: "24px",
      width: "100%",
      maxWidth: 400,
      boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
      position: "relative",
      maxHeight: "90vh",
      overflowY: "auto"
    },
    input: {
      width: "100%",
      padding: "14px 16px",
      margin: "6px 0",
      border: "2px solid #e1e5e9",
      borderRadius: 12,
      fontSize: 16,
      background: "#f8f9fa",
      transition: "all 0.3s ease",
      boxSizing: "border-box",
      outline: "none"
    },
    inputRow: {
      display: "flex",
      gap: 8,
      width: "100%",
      alignItems: "flex-start"
    },
    checkBtn: {
      padding: "14px 12px",
      background: COLOR,
      color: "#fff",
      border: "none",
      borderRadius: 12,
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      transition: "all 0.3s ease",
      whiteSpace: "nowrap",
      minWidth: 90
    },
    btn: {
      width: "100%",
      padding: "16px",
      background: COLOR,
      color: "#fff",
      border: "none",
      borderRadius: 16,
      fontSize: 16,
      fontWeight: 700,
      cursor: "pointer",
      margin: "12px 0",
      transition: "all 0.3s ease",
      boxShadow: "0 8px 25px rgba(102, 126, 234, 0.4)"
    },
    popup: {
      position: "fixed",
      top: 20,
      left: "50%",
      transform: "translateX(-50%)",
      color: "#fff",
      padding: "12px 20px",
      borderRadius: 12,
      fontSize: 14,
      fontWeight: 600,
      zIndex: 10000,
      boxShadow: "0 8px 25px rgba(0,0,0,0.3)",
      maxWidth: "calc(100vw - 40px)",
      textAlign: "center",
      animation: "slideDown 0.3s ease"
    }
  };

  const focusStyle = {
    borderColor: COLOR,
    background: "#fff",
    boxShadow: `0 0 0 3px ${COLOR}30`
  };

  return (
    <div style={styles.container}>
      {/* 중복확인 팝업 */}
      {showPopup && (
        <div style={{
          ...styles.popup,
          background: popupType === "success" ? "#10b981" : "#ef4444"
        }}>
          {popupMessage}
        </div>
      )}

      <div style={styles.card}>
        {/* 헤더 */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🏆</div>
          <div style={{
            fontSize: 24,
            fontWeight: 900,
            color: COLOR,
            marginBottom: 6
          }}>
            {isLogin ? "로그인" : `${userType === 'association' ? '협회' : '일반'} 회원가입`}
          </div>
          <div style={{ fontSize: 14, color: "#6c757d" }}>
            {isLogin ? "Sportier에 오신 것을 환영합니다" : "새로운 계정을 만들어보세요"}
          </div>
        </div>

        {/* 로그인 폼 */}
        {isLogin && (
          <>
            <input
              placeholder="아이디"
              value={id}
              onChange={e => setId(e.target.value)}
              style={styles.input}
              onFocus={e => Object.assign(e.target.style, focusStyle)}
              onBlur={e => {
                e.target.style.borderColor = "#e1e5e9";
                e.target.style.background = "#f8f9fa";
                e.target.style.boxShadow = "none";
              }}
            />
            <input
              type="password"
              placeholder="비밀번호"
              value={pw}
              onChange={e => setPw(e.target.value)}
              style={styles.input}
              onFocus={e => Object.assign(e.target.style, focusStyle)}
              onBlur={e => {
                e.target.style.borderColor = "#e1e5e9";
                e.target.style.background = "#f8f9fa";
                e.target.style.boxShadow = "none";
              }}
            />
            {error && (
              <div style={{
                color: "#dc3545",
                margin: "10px 0",
                textAlign: "center",
                fontWeight: 600,
                background: "#fee",
                padding: "10px",
                borderRadius: 8,
                fontSize: 13
              }}>
                {error}
              </div>
            )}
            <button
              onClick={handleLogin}
              disabled={loading}
              style={{
                ...styles.btn,
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer"
              }}
            >
              {loading ? "로그인 중..." : "로그인"}
            </button>
            <button
              onClick={handleGoogleLogin}
              disabled={loading}
              style={{
                ...styles.btn,
                background: "#fff",
                color: "#333",
                border: `2px solid ${COLOR}`,
                fontSize: 15,
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                opacity: loading ? 0.7 : 1
              }}
            >
              <img src={googleLogo} alt="google" width={20} height={20} />
              Google 계정으로 로그인
            </button>
            <div style={{
              marginTop: 20,
              textAlign: "center",
              color: "#6c757d",
              fontSize: 14
            }}>
              회원이 아니신가요?
              <button
                onClick={() => {
                  setIsLogin(false);
                  resetForm();
                }}
                style={{
                  background: "none",
                  border: "none",
                  color: COLOR,
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: 600,
                  marginLeft: 6,
                  textDecoration: "underline"
                }}
              >
                회원가입
              </button>
            </div>
          </>
        )}

        {/* 회원가입 폼 */}
        {!isLogin && (
          <>
            {/* 회원 타입 선택 */}
            <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
              <button
                onClick={() => { setUserType("general"); resetForm(); }}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: userType === "general" ? COLOR : "#f8f9fa",
                  color: userType === "general" ? "#fff" : "#6c757d",
                  border: `2px solid ${userType === "general" ? COLOR : "#e1e5e9"}`,
                  borderRadius: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  fontSize: 14
                }}>
                👤 일반회원
              </button>
              <button
                onClick={() => { setUserType("association"); resetForm(); }}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: userType === "association" ? COLOR : "#f8f9fa",
                  color: userType === "association" ? "#fff" : "#6c757d",
                  border: `2px solid ${userType === "association" ? COLOR : "#e1e5e9"}`,
                  borderRadius: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  fontSize: 14
                }}>
                🏢 협회
              </button>
            </div>

            {/* 공통 입력란 */}
            <div style={styles.inputRow}>
              <input placeholder="아이디 (4자 이상)" value={id} onChange={e => { setId(e.target.value); setIdCheck(false); }} style={{ ...styles.input, flex: 1, margin: 0 }} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
              <button onClick={() => checkDuplicate("id", id, setIdCheck)} disabled={loading || !id.trim()} style={{ ...styles.checkBtn, background: idCheck ? "#10b981" : COLOR, opacity: loading || !id.trim() ? 0.6 : 1, cursor: loading || !id.trim() ? "not-allowed" : "pointer" }}>
                {idCheck ? "✓" : "중복확인"}
              </button>
            </div>
            <input type="password" placeholder="비밀번호 (8자 이상, 대소문자+숫자+특수문자)" value={pw} onChange={e => setPw(e.target.value)} style={styles.input} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
            <div style={{ position: "relative" }}>
              <input type="password" placeholder="비밀번호 확인" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} style={{ ...styles.input, borderColor: confirmPw && pw !== confirmPw ? "#ef4444" : "#e1e5e9" }} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = confirmPw && pw !== confirmPw ? "#ef4444" : "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
              {confirmPw && pw !== confirmPw && (<div style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "#ef4444", fontSize: 12, fontWeight: 600 }}>✗</div>)}
              {confirmPw && pw === confirmPw && pw.length > 0 && (<div style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "#10b981", fontSize: 12, fontWeight: 600 }}>✓</div>)}
            </div>
            <div style={styles.inputRow}>
              <input placeholder="이메일" type="email" value={email} onChange={e => { setEmail(e.target.value); setEmailCheck(false); }} style={{ ...styles.input, flex: 1, margin: 0 }} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
              <button onClick={() => checkDuplicate("email", email, setEmailCheck)} disabled={loading || !email.trim()} style={{ ...styles.checkBtn, background: emailCheck ? "#10b981" : COLOR, opacity: loading || !email.trim() ? 0.6 : 1, cursor: loading || !email.trim() ? "not-allowed" : "pointer" }}>
                {emailCheck ? "✓" : "중복확인"}
              </button>
            </div>
            <input placeholder="전화번호" value={phone} onChange={e => setPhone(e.target.value)} style={styles.input} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />

            {/* 일반회원 전용 입력란 */}
            {userType === "general" && (
              <>
                <div style={styles.inputRow}>
                  <input placeholder="닉네임" value={nickname} onChange={e => { setNickname(e.target.value); setNicknameCheck(false); }} style={{ ...styles.input, flex: 1, margin: 0 }} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
                  <button onClick={() => checkDuplicate("nickname", nickname, setNicknameCheck)} disabled={loading || !nickname.trim()} style={{ ...styles.checkBtn, background: nicknameCheck ? "#10b981" : COLOR, opacity: loading || !nickname.trim() ? 0.6 : 1, cursor: loading || !nickname.trim() ? "not-allowed" : "pointer" }}>
                    {nicknameCheck ? "✓" : "중복확인"}
                  </button>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <select value={gender} onChange={e => setGender(e.target.value)} style={{ ...styles.input, flex: 1 }}>
                    <option value="">성별 선택</option>
                    <option value="남성">남성</option>
                    <option value="여성">여성</option>
                  </select>
                  <input type="date" value={birth} onChange={e => setBirth(e.target.value)} style={{ ...styles.input, flex: 1 }} />
                </div>
              </>
            )}

            {/* 협회회원 전용 입력란 */}
            {userType === "association" && (
              <>
                <div style={styles.inputRow}>
                  <input placeholder="협회명" value={associationName} onChange={e => { setAssociationName(e.target.value); setAssociationNameCheck(false); }} style={{ ...styles.input, flex: 1, margin: 0 }} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
                  <button onClick={() => checkDuplicate("associationName", associationName, setAssociationNameCheck)} disabled={loading || !associationName.trim()} style={{ ...styles.checkBtn, background: associationNameCheck ? "#10b981" : COLOR, opacity: loading || !associationName.trim() ? 0.6 : 1, cursor: loading || !associationName.trim() ? "not-allowed" : "pointer" }}>
                    {associationNameCheck ? "✓" : "중복확인"}
                  </button>
                </div>
                <input placeholder="사업자번호" value={businessNumber} onChange={e => setBusinessNumber(e.target.value)} style={styles.input} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
                <input placeholder="협회 주소" value={associationAddress} onChange={e => setAssociationAddress(e.target.value)} style={styles.input} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
                <input placeholder="대표자명" value={representativeName} onChange={e => setRepresentativeName(e.target.value)} style={styles.input} onFocus={e => Object.assign(e.target.style, focusStyle)} onBlur={e => { e.target.style.borderColor = "#e1e5e9"; e.target.style.background = "#f8f9fa"; e.target.style.boxShadow = "none"; }} />
                <div style={{ marginTop: 12 }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#374151", marginBottom: 8 }}>운영 종목 선택 (중복 선택 가능)</div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                    {AVAILABLE_SPORTS.map(sport => (
                      <button key={sport} type="button" onClick={() => handleSportToggle(sport)} style={{ padding: "10px 12px", background: sports.includes(sport) ? COLOR : "#f8f9fa", color: sports.includes(sport) ? "#fff" : "#6c757d", border: `2px solid ${sports.includes(sport) ? COLOR : "#e1e5e9"}`, borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer", transition: "all 0.3s ease" }}>{sport}</button>
                    ))}
                  </div>
                  {sports.length > 0 && (<div style={{ marginTop: 8, fontSize: 12, color: "#10b981", fontWeight: 600 }}>선택된 종목: {sports.join(", ")}</div>)}
                </div>
              </>
            )}

            {/* 에러/성공 메시지 */}
            {error && (<div style={{ color: "#dc3545", margin: "12px 0", textAlign: "center", fontWeight: 600, background: "#fee", padding: "10px", borderRadius: 8, fontSize: 13 }}>{error}</div>)}
            {info && (<div style={{ color: "#10b981", margin: "12px 0", textAlign: "center", fontWeight: 600, background: "#f0fdf4", padding: "10px", borderRadius: 8, fontSize: 13 }}>{info}</div>)}

            <button onClick={handleRegister} disabled={loading} style={{ ...styles.btn, opacity: loading ? 0.7 : 1, cursor: loading ? "not-allowed" : "pointer", marginTop: 16 }}>{loading ? "가입 중..." : `${userType === 'association' ? '협회' : ''} 회원가입`}</button>
            <div style={{ marginTop: 16, textAlign: "center", color: "#6c757d", fontSize: 14 }}>
              이미 회원이신가요?
              <button onClick={() => { setIsLogin(true); resetForm(); }} style={{ background: "none", border: "none", color: COLOR, cursor: "pointer", fontSize: 14, fontWeight: 600, marginLeft: 6, textDecoration: "underline" }}>로그인</button>
            </div>
          </>
        )}
      </div>

      {/* ----- CSS 영역 ----- */}
              <style>{`
        @keyframes slideDown {
          from { transform: translateX(-50%) translateY(-100%); opacity: 0; }
          to { transform: translateX(-50%) translateY(0); opacity: 1; }
        }
        @media (max-width: 480px) {
          .card { margin: 8px; padding: 20px; max-width: calc(100vw - 32px); }
          .input-row { flex-direction: column; gap: 8px; }
          .check-btn { width: 100%; min-width: auto; }
        }
        @media (max-width: 360px) {
          .card { padding: 16px; border-radius: 16px; }
          .header-title { font-size: 20px; }
          .sports-grid { grid-template-columns: 1fr; }
        }
        input:focus, select:focus { transform: translateY(-1px); }
        button:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 8px 25px rgba(102,126,234,0.3); }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 3px; }
        ::-webkit-scrollbar-thumb { background: ${COLOR}; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: #555; }
        @media (hover: none) and (pointer: coarse) {
          button { min-height: 44px; }
          input, select { min-height: 44px; font-size: 16px; }
        }
        @media (prefers-color-scheme: dark) {
          .card { background: #1f2937; color: #f9fafb; }
          input, select { background: #374151; color: #f9fafb; border-color: #4b5563; }
          input::placeholder { color: #9ca3af; }
        }
        button:focus { outline: 2px solid ${COLOR}; outline-offset: 2px; }
        input:focus, select:focus { outline: 2px solid ${COLOR}; outline-offset: 2px; }
        @keyframes pulse { 0%,100%{opacity:1;} 50%{opacity:0.5;} }
        .loading { animation: pulse 2s cubic-bezier(0.4,0,0.6,1) infinite; }
        @keyframes fadeIn { from{opacity:0;transform:translateY(-10px);} to{opacity:1;transform:translateY(0);} }
        .message { animation: fadeIn 0.3s ease; }
        * { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; -webkit-tap-highlight-color: transparent; }
        input, textarea { -webkit-user-select: text; user-select: text; }
        input:focus-visible, select:focus-visible, button:focus-visible { outline: 2px solid ${COLOR}; outline-offset: 2px; }
        @media (max-width: 380px) { .sports-grid { grid-template-columns: 1fr; } }
        @media (prefers-contrast: high) {
          .card { border: 2px solid #000; }
          input, select, button { border: 2px solid #000; }
        }
        @media (prefers-reduced-motion: reduce) { * { animation-duration:0.01ms!important; animation-iteration-count:1!important; transition-duration:0.01ms!important; } }
        @supports (-webkit-appearance: none) {
          input { -webkit-appearance: none; border-radius: 12px; }
          select { -webkit-appearance: none; background-image: url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><path fill='%23666' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>"); background-repeat: no-repeat; background-position: right 12px center; background-size: 12px; }
        }
        @media screen and (orientation: landscape) and (max-height: 500px) {
          .card { max-height: 85vh; padding: 16px; }
          .header { margin-bottom: 16px; }
          .header-icon { font-size: 32px; margin-bottom: 8px; }
          .header-title { font-size: 20px; }
        }
        @media (max-width: 320px) {
          .card { font-size: 14px; }
          input, select, button { font-size: 14px; padding: 12px 14px; }
          .check-btn { font-size: 12px; padding: 12px 8px; }
        }
      `}</style>
    </div>
  );
}

export default LoginRegister;
